module.exports = __webpack_public_path__ + "img/almithalylogo.7a18208d.svg";